
/*
 * Copyright © 2015-2018 Serenova, LLC. All rights reserved.
 */

import React from 'react';
import PropTypes from 'prop-types';
import { camelCaseToRegularForm, capitalizeFirstLetter } from 'serenova-js-utils/strings';
import { SortFilterSelect } from 'cx-ui-components';

import styled from 'styled-components';
import { SearchIconSVG,FilterSelect } from 'cx-ui-components';

const Input = styled.input`
  width: 100%;
`;
const SearchIcon = styled(SearchIconSVG)`
  position: relative;
  left: -17px;
  opacity: 0.4;
`;

export function audioRecordingTypeColumn(string, customString) {
  let options=['All','Conference Customer','Conference Agent','Conference External','IVR Snippet','Quality Management','Voicemail']
  const column = {
    id: string,
    Header: <span title='Audio Recording Type'>Artifact SubType</span>,
    accessor: string,
    Cell: ({ row }) => {
        if(row[string]=="null"){
          row[string]="";
        } 
        return <span title={row[string]}>{row[string]}</span>; 
    },
    Filter: ({ filter, onChange }) => (

      <SortFilterSelect
        tableType="modal"
        onChange={event => onChange(event.target.value)}
        value={filter ? filter.value : 'All'}
        excludeSortingOfItems={["All"]}
        options={options}
      />
    ),
    filterMethod: (filter, row) => {
        if (filter.value === 'All') {
          return true;
        }
        if (options.includes(filter.value)) {
          return row[string]===filter.value;
        }
      }
  };
  column.Cell.propTypes = {
    row: PropTypes.any
  };
  column.Filter.propTypes = {
    filter: PropTypes.func,
    onChange: PropTypes.func
  };

  return column;
}
